import React from 'react';
import api from '../../../helpers/api';

import styles from './ContactUs.module.scss';
import MultiSelect from '../../miscellaneous/MultiSelect/MultiSelect';
import Loader from '../../miscellaneous/Loader/Loader';
import { $t } from '../../../helpers/translator';
import _ from "lodash";

class ContactUs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            successMessage: '',
            errorMessage: '',
            loading: false,

            values: {
                email: {
                    value: '',
                    validation: [
                        {
                            regex: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                            errorText: $t('validation.general.email')
                        },
                        {
                            regex: /^.{0,255}$/i,
                            errorText: $t('validation.general.maxLength').replace('[0]', '255')
                        },
                        {
                            required: $t('validation.general.required')
                        }
                    ],
                    error: ''
                },
                name: {
                    value: '',
                    validation: [
                        {
                            regex: /^.{0,255}$/i,
                            errorText: $t('validation.general.maxLength').replace('[0]', '255')
                        },
                        {
                            regex: /^.+$/i,
                            errorText: $t('validation.general.required')
                        }
                    ],
                    error: ''
                },
                problem_text: {
                    value: '',
                    validation: [
                        {
                            regex: /^.+$/i,
                            errorText: $t('validation.general.required')
                        }
                    ],
                    error: ''
                },
                submitterCountry: {
                    value: '',
                    validation: [
                        {
                            regex: /^.+$/i,
                            errorText: $t('validation.general.required')
                        }
                    ],
                    error: ''
                },
                submitterMachine: {
                    value: '',
                    validation: [
                        // {
                        //     regex: /^.+$/i,
                        //     errorText: $t('validation.general.required')
                        // }
                    ],
                    error: ''
                },
                text: {
                    value: '',
                    validation: [
                        {
                            maxLength: 255
                        },
                        {
                            required: $t('validation.general.required')
                        }
                    ],
                    error: ''
                },
            },
            issueTitles: [
                {
                    value: 1,
                    label: $t('global.service.contactUs.machinesConnectionAndManagement')
                },
                {
                    value: 2,
                    label: $t('global.service.contactUs.staffManagement')
                },
                {
                    value: 3,
                    label: $t('global.service.contactUs.patientsManagement')
                },
                {
                    value: 4,
                    label: $t('global.service.contactUs.other')
                },
            ]
        };

    }

    async componentDidMount() {
        await this.getCountries();
        await this.getClinicMachines();
    }

    componentWillReceiveProps(nextProps) {
        this.resetForm()
    }

    async getCountries() {
        try {
            // let res = await api.fetchCountryList();
            let res = await api.get('/general/countries')
            if (res && res.data && res.data.data) {
                _.forEach(res.data.data, (v, k) => {
                    v.label = $t('countries.' + v.name);
                    v.value = v.id;
                });
                this.setState({ countries: res.data.data });
            }
        } catch (e) {
            console.error('err getting countries,', e);
        }
    }

    async getClinicMachines() {
        try {
            // let res = await api.fetchClinicMachinesList();
            let res = await api.get('/dashboard/platforms');
            // console.log('...re', res);
            if (res && res.data) {
                _.forEach(res.data, (v, k) => {
                    v.label = v.machineName;
                    v.value = v.machineName;
                });
                this.setState({ clinicMachines: res.data });
            }
        } catch (e) {
            console.error('err getting countries,', e);
        }
    }


    async formSentClickHandler() {
        this.setState({
            successMessage: '',
            errorMessage: ''
        });

        let validated = this.validateForm();
        if (validated) {
            let payload = {
                email: this.state.values.email.value,
                name: this.state.values.name.value,
                submitterCountry: this.state.values.submitterCountry.value.label,
                problem_text: this.state.values.problem_text.value.label,
                submitterMachine: this.state.values.submitterMachine.value.label,
                text: this.state.values.text.value,
            };

            // console.log('FORM VALIDATED! SENDING DATA.', payload);
            try {
                this.setState({ loading: true }, async () => {
                    // let res = await api.sendContactUs(payload);
                    // let res = await api.post('clinic/contactus', payload);
                    let res = await api.post('/help/contact', payload);
                    // console.log('ggg', res);

                    if (!res || !res.data || !res.data.success) {
                        let error = res.error ? res.error : $t('global.service.contactUs.errorSubmittingForm');
                        this.setState({
                            errorMessage: error,
                            loading: false
                        });
                        return;
                    }
                    this.setState({
                        successMessage: $t('global.service.contactUs.successSubmittingForm'),
                        loading: false
                    });
                });


            } catch (e) {
                console.error('err sending contact us', e);
            }

        }
    }

    validateForm() {
        let validated = true;
        let values = { ...this.state.values };

        _.forEach(values, (v, k) => {
            v.error = '';
            _.forEach(v.validation, (valObj, valKey) => {

                if (valObj.regex) {
                    // console.log(k, v.value, valObj, (valObj.regex).test(v.value));
                    if (!(valObj.regex).test(v.value)) {
                        v.error = valObj.errorText;
                        validated = false;
                    }
                }
                if (valObj.required && !v.value.length) {
                    // console.log(k, v.value, 'Required', v.value.length);
                    v.error = valObj.required;
                    validated = false;
                }
                if (valObj.maxLength && v.value.length > valObj.maxLength) {
                    // console.log(k, v.value, 'maxLength', v.value.length);
                    v.error = 'Length should not exceed ' + valObj.maxLength + 'characters';
                    validated = false;
                }
            });
        });

        this.setState({ values: values });

        return validated;
    }

    valueChangeHandler(e) {
        // console.log('valueChangeHandler-valueChangeHandler', e.target.name, e.target.value);
        let values = { ...this.state.values };
        values[e.target.name].value = e.target.value;
        values[e.target.name].error = '';

        this.setState({ values: values });
    }

    selectChangeHandler(field, data) {
        // console.log(data);
        let values = { ...this.state.values };
        values[field].value = data;
        values[field].error = '';

        this.setState({ values: values });
    }

    resetForm() {
        let state = { ...this.state };

        state.successMessage = '';
        state.errorMessage = '';
        _.forEach(state.values, (v, k) => {
            v.value = '';
            v.error = '';
        })

        this.setState(state);
    }

    render() {

        return (
            <div className={`${styles['container']}`}>
                {this.state.successMessage ?
                    <div className={`${styles['success']}`}>
                        <div>{this.state.successMessage}</div>
                    </div>
                    :
                    null
                }
                {
                    this.state.loading ?
                        <div className={`${styles['overlay']}`}>
                            <Loader/>
                        </div>
                        :
                        null
                }
                {!this.state.successMessage ?
                    <div>
                        <div className={`${styles['row']} ${styles['cu-header']}`}>
                            <div>{$t('global.service.contactUs.contactUs')}</div>
                        </div>
                        <div className={`${styles['row']}` }>
                            <div className={`${styles['field']}` } style={{minWidth: '250px'}}>
                                <div className={`${styles['field-header']}` }>{$t('global.service.contactUs.name')}</div>
                                <input name="name"
                                       className={'alma-input'}
                                       type="text"
                                       value={this.state.values.name.value}
                                       placeholder={$t('global.service.contactUs.enterYourName')}
                                       onChange={(e) => this.valueChangeHandler(e)}
                                />
                                <div className={`${styles['error-text']}` }>{this.state.values.name.error}</div>
                            </div>
                            <div className={`${styles['field']}` } style={{width: '250px'}}>
                                <div className={`${styles['field-header']}` }>{$t('global.service.contactUs.email')}</div>
                                <input name="email"
                                       className={'alma-input'}
                                       type="text"
                                       value={this.state.values.email.value}
                                       placeholder={$t('global.service.contactUs.enterEmail')}
                                       onChange={(e) => this.valueChangeHandler(e)}
                                />
                                <div className={`${styles['error-text']}` }>{this.state.values.email.error}</div>
                            </div>
                        </div>

                        <div className={`${styles['field']}` }>
                            <div className={`${styles['field-header']}` }>{$t('global.service.contactUs.country')}</div>
                            {this.state.countries ?
                                <MultiSelect
                                    name="submitterCountry"
                                    options={this.state.countries}
                                    selected={this.state.values.submitterCountry.value}
                                    onValueChange={(data) => this.selectChangeHandler('submitterCountry', data)}
                                />
                                :
                                null
                            }
                            <div className={`${styles['error-text']}` }>{this.state.values.submitterCountry.error}</div>
                        </div>

                        <div className={`${styles['br']}`}> </div>

                        <div className={`${styles['field']}` }>
                            <div className={`${styles['field-header']}` }>{$t('global.service.contactUs.title')}</div>
                            <MultiSelect
                                name={'problem_text'}
                                options={this.state.issueTitles}
                                selected={this.state.values.problem_text.value}
                                onValueChange={(data) => this.selectChangeHandler('problem_text', data)}
                            />
                            <div className={`${styles['error-text']}` }>{this.state.values.problem_text.error}</div>
                        </div>

                        <div className={`${styles['field']}` }>
                            <div className={`${styles[(this.state.values.problem_text.value.value !== 1 ? 'display-none' : '')]}`}>
                                <div className={`${styles['field-header']}` }>{$t('global.service.contactUs.machine')}</div>
                                <MultiSelect
                                    name={'submitterMachine'}
                                    options={this.state.clinicMachines}
                                    selected={this.state.values.submitterMachine.value}
                                    onValueChange={(data) => this.selectChangeHandler('submitterMachine', data)}
                                />
                                <div className={`${styles['error-text']}` }>{this.state.values.submitterMachine.error}</div>
                            </div>
                        </div>

                        <div className={`${styles['field']}` }>
                            <div className={`${styles['field-header']}` }>{$t('global.service.contactUs.content')}</div>
                            <textarea name="text"
                                      className={'alma-input alma-input-textarea'}
                                      style={{height: '150px'}}
                                      rows={5}
                                      value={this.state.values.text.value}
                                      placeholder={$t('global.service.contactUs.explainProblem')}
                                      onChange={(e) => this.valueChangeHandler(e)}
                            />
                            <div className={`${styles['error-text']}` }>{this.state.values.text.error}</div>
                        </div>

                        <div className={`${styles['row']} ${styles['bottom-row']}`}>
                            <div className={'alma-button'}
                                 onClick={() => this.formSentClickHandler()}>{$t('global.service.contactUs.submit')}</div>
                        </div>
                        <div className={`${styles['row']} ${styles['bottom-row']} ${styles['error']}`}>
                            <div>{this.state.errorMessage}</div>
                        </div>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

export default ContactUs;
